import {
    Box,
    Button,
    Card,
    Divider,
    FormControlLabel,
    Grid,
    OutlinedInput,
    Radio,
    RadioGroup,
    Stack,
    Typography,
} from '@mui/material';
import React, { useState } from 'react';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface TypeOption {
    data: any;
}



const ExpansionDetails = (props: TypeOption) => {
    const { data } = props;
    const [medicalOpen, setMedicalOpen] = useState(false);
    const [mobilityOpen, setMobilityOpen] = useState(false);
    const [cognitionOpen, setCognitionOpen] = useState(false);
    const [selfCareOpen, setSelfCareOpen] = useState(false);
    const [swallowingOpen, setSwallowingOpen] = useState(false);

    const icon = medicalOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />;
    const iconMobility = mobilityOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />;
    const iconCognition = cognitionOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />;
    const iconSelfCare = selfCareOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />;
    const iconSwallowing = swallowingOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />;

    return (
        <>
            <Stack>
                <Button
                    onClick={(event) => setMedicalOpen((prev) => !prev)}
                    endIcon={icon}
                    sx={{
                        padding: '0 1.5rem',
                        height: '70px',
                        borderRadius: '0px',
                        justifyContent: 'space-between',
                        color: 'black',
                    }}
                >
                    <Typography variant="h6">{'Medical'}</Typography>
                </Button>
                <Divider />
            </Stack>
            {medicalOpen && (
                <Grid
                    spacing={3}>
                    <Grid
                        container
                        spacing={3}
                        sx={{ padding: '10px 1.5rem' }}
                    >
                        <Grid
                            item
                            xs={4}
                        >
                            <Typography variant='subtitle1'>Medical Status & Medication</Typography>
                        </Grid>
                        <Grid item
                            xs={2}>
                            <Typography variant='body2'>{data?.medicalStatusAndMedication === true ? 'Yes' : 'No'}</Typography>

                        </Grid>
                        <Grid item
                            xs={6}>
                            <Typography variant='body2'>{data?.medicalStatusAndMedicationComment ? data?.medicalStatusAndMedicationComment : '-'}</Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={3}
                        sx={{ padding: '10px 1.5rem' }}
                    >
                        <Grid
                            item
                            xs={4}
                        >
                            <Typography variant='subtitle1'>Pain Affecting Daily Routine</Typography>
                        </Grid>
                        <Grid item
                            xs={2}>
                            <Typography variant='body2'>{data?.painAffectingDailyRoutine === true ? 'Yes' : 'No'}</Typography>

                        </Grid>
                        <Grid item
                            xs={6}>
                            <Typography variant='body2'>{data?.transferComment ? data?.transferComment : '-'}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            )}
            <Stack>
                <Button
                    onClick={(event) => setMobilityOpen((prev) => !prev)}
                    endIcon={iconMobility}
                    sx={{
                        padding: '0 1.5rem',
                        height: '70px',
                        borderRadius: '0px',
                        justifyContent: 'space-between',
                        color: 'black',
                    }}
                >
                    <Typography variant="h6">{'Mobility'}</Typography>
                </Button>
                <Divider />
            </Stack>
            {mobilityOpen && (
                <Grid
                    spacing={3}>
                    <Grid
                        container
                        spacing={3}
                        sx={{ padding: '10px 1.5rem' }}
                    >
                        <Grid
                            item
                            xs={4}
                        >
                            <Typography variant='subtitle1'>Bad Mobility</Typography>
                        </Grid>
                        <Grid item
                            xs={2}>
                            <Typography variant='body2'>{data?.badMobility === true ? 'Yes' : 'No'}</Typography>

                        </Grid>
                        <Grid item
                            xs={6}>
                            <Typography variant='body2'>{data?.badMobilityComment ? data?.badMobilityComment : '-'}</Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={3}
                        sx={{ padding: '10px 1.5rem' }}
                    >
                        <Grid
                            item
                            xs={4}
                        >
                            <Typography variant='subtitle1'>Transfer</Typography>
                        </Grid>
                        <Grid item
                            xs={2}>
                            <Typography variant='body2'>{data?.transfer === true ? 'Yes' : 'No'}</Typography>

                        </Grid>
                        <Grid item
                            xs={6}>
                            <Typography variant='body2'>{data?.painAffectingDailyRoutineComment ? data?.painAffectingDailyRoutineComment : '-'}</Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={3}
                        sx={{ padding: '10px 1.5rem' }}
                    >
                        <Grid
                            item
                            xs={4}
                        >
                            <Typography variant='subtitle1'>Ambulations</Typography>
                        </Grid>
                        <Grid item
                            xs={2}>
                            <Typography variant='body2'>{data?.ambulations === true ? 'Yes' : 'No'}</Typography>

                        </Grid>
                        <Grid item
                            xs={6}>
                            <Typography variant='body2'>{data?.ambulationsComment ? data?.ambulationsComment : '-'}</Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={3}
                        sx={{ padding: '10px 1.5rem' }}
                    >
                        <Grid
                            item
                            xs={4}
                        >
                            <Typography variant='subtitle1'>Assistive Device(s) | DME</Typography>
                        </Grid>
                        <Grid item
                            xs={2}>
                            <Typography variant='body2'>{data?.assistiveDevice === true ? 'Yes' : 'No'}</Typography>

                        </Grid>
                        <Grid item
                            xs={6}>
                            <Typography variant='body2'>{data?.assistiveDeviceComment ? data?.assistiveDeviceComment : '-'}</Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={3}
                        sx={{ padding: '10px 1.5rem' }}
                    >
                        <Grid
                            item
                            xs={4}
                        >
                            <Typography variant='subtitle1'>Recent Fall(s)</Typography>
                        </Grid>
                        <Grid item
                            xs={2}>
                            <Typography variant='body2'>{data?.recentFall === true ? 'Yes' : 'No'}</Typography>

                        </Grid>
                        <Grid item
                            xs={6}>
                            <Typography variant='body2'>{data?.recentFallComment ? data?.recentFallComment : '-'}</Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={3}
                        sx={{ padding: '10px 1.5rem' }}
                    >
                        <Grid
                            item
                            xs={4}
                        >
                            <Typography variant='subtitle1'>Orthotics | Splints | Prosthetics</Typography>
                        </Grid>
                        <Grid item
                            xs={2}>
                            <Typography variant='body2'>{data?.orthotics === true ? 'Yes' : 'No'}</Typography>

                        </Grid>
                        <Grid item
                            xs={6}>
                            <Typography variant='body2'>{data?.orthoticsComment ? data?.orthoticsComment : '-'}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            )}
             <Stack>
                <Button
                    onClick={(event) => setCognitionOpen((prev) => !prev)}
                    endIcon={iconCognition}
                    sx={{
                        padding: '0 1.5rem',
                        height: '70px',
                        borderRadius: '0px',
                        justifyContent: 'space-between',
                        color: 'black',
                    }}
                >
                    <Typography variant="h6">{'Cognition/Communication'}</Typography>
                </Button>
                <Divider />
            </Stack>
            {cognitionOpen && (
                <Grid
                    spacing={3}>
                    <Grid
                        container
                        spacing={3}
                        sx={{ padding: '10px 1.5rem' }}
                    >
                        <Grid
                            item
                            xs={4}
                        >
                            <Typography variant='subtitle1'>Cognition</Typography>
                        </Grid>
                        <Grid item
                            xs={2}>
                            <Typography variant='body2'>{data?.medicalStatusAndMedication === true ? 'Yes' : 'No'}</Typography>

                        </Grid>
                        <Grid item
                            xs={6}>
                            <Typography variant='body2'>{data?.medicalStatusAndMedicationComment ? data?.medicalStatusAndMedicationComment : '-'}</Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={3}
                        sx={{ padding: '10px 1.5rem' }}
                    >
                        <Grid
                            item
                            xs={4}
                        >
                            <Typography variant='subtitle1'>Recent ACL and/or BIMS Score</Typography>
                        </Grid>
                        <Grid item
                            xs={2}>
                            <Typography variant='body2'>{data?.painAffectingDailyRoutine === true ? 'Yes' : 'No'}</Typography>

                        </Grid>
                        <Grid item
                            xs={6}>
                            <Typography variant='body2'>{data?.transferComment ? data?.transferComment : '-'}</Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={3}
                        sx={{ padding: '10px 1.5rem' }}
                    >
                        <Grid
                            item
                            xs={4}
                        >
                            <Typography variant='subtitle1'>Communication</Typography>
                        </Grid>
                        <Grid item
                            xs={2}>
                            <Typography variant='body2'>{data?.painAffectingDailyRoutine === true ? 'Yes' : 'No'}</Typography>

                        </Grid>
                        <Grid item
                            xs={6}>
                            <Typography variant='body2'>{data?.transferComment ? data?.transferComment : '-'}</Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={3}
                        sx={{ padding: '10px 1.5rem' }}
                    >
                        <Grid
                            item
                            xs={4}
                        >
                            <Typography variant='subtitle1'>Vision</Typography>
                        </Grid>
                        <Grid item
                            xs={2}>
                            <Typography variant='body2'>{data?.painAffectingDailyRoutine === true ? 'Yes' : 'No'}</Typography>

                        </Grid>
                        <Grid item
                            xs={6}>
                            <Typography variant='body2'>{data?.transferComment ? data?.transferComment : '-'}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            )}
             <Stack>
                <Button
                    onClick={(event) => setSelfCareOpen((prev) => !prev)}
                    endIcon={iconSelfCare}
                    sx={{
                        padding: '0 1.5rem',
                        height: '70px',
                        borderRadius: '0px',
                        justifyContent: 'space-between',
                        color: 'black',
                    }}
                >
                    <Typography variant="h6">{'Self-care'}</Typography>
                </Button>
                <Divider />
            </Stack>
            {selfCareOpen && (
                <Grid
                    spacing={3}>
                    <Grid
                        container
                        spacing={3}
                        sx={{ padding: '10px 1.5rem' }}
                    >
                        <Grid
                            item
                            xs={4}
                        >
                            <Typography variant='subtitle1'>Self Feeding</Typography>
                        </Grid>
                        <Grid item
                            xs={2}>
                            <Typography variant='body2'>{data?.badMobility === true ? 'Yes' : 'No'}</Typography>

                        </Grid>
                        <Grid item
                            xs={6}>
                            <Typography variant='body2'>{data?.badMobilityComment ? data?.badMobilityComment : '-'}</Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={3}
                        sx={{ padding: '10px 1.5rem' }}
                    >
                        <Grid
                            item
                            xs={4}
                        >
                            <Typography variant='subtitle1'>Oral Hygiene | Grooming</Typography>
                        </Grid>
                        <Grid item
                            xs={2}>
                            <Typography variant='body2'>{data?.transfer === true ? 'Yes' : 'No'}</Typography>

                        </Grid>
                        <Grid item
                            xs={6}>
                            <Typography variant='body2'>{data?.painAffectingDailyRoutineComment ? data?.painAffectingDailyRoutineComment : '-'}</Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={3}
                        sx={{ padding: '10px 1.5rem' }}
                    >
                        <Grid
                            item
                            xs={4}
                        >
                            <Typography variant='subtitle1'>Dressing</Typography>
                        </Grid>
                        <Grid item
                            xs={2}>
                            <Typography variant='body2'>{data?.ambulations === true ? 'Yes' : 'No'}</Typography>

                        </Grid>
                        <Grid item
                            xs={6}>
                            <Typography variant='body2'>{data?.ambulationsComment ? data?.ambulationsComment : '-'}</Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={3}
                        sx={{ padding: '10px 1.5rem' }}
                    >
                        <Grid
                            item
                            xs={4}
                        >
                            <Typography variant='subtitle1'>Toileting</Typography>
                        </Grid>
                        <Grid item
                            xs={2}>
                            <Typography variant='body2'>{data?.assistiveDevice === true ? 'Yes' : 'No'}</Typography>

                        </Grid>
                        <Grid item
                            xs={6}>
                            <Typography variant='body2'>{data?.assistiveDeviceComment ? data?.assistiveDeviceComment : '-'}</Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={3}
                        sx={{ padding: '10px 1.5rem' }}
                    >
                        <Grid
                            item
                            xs={4}
                        >
                            <Typography variant='subtitle1'>Bathing | Showering</Typography>
                        </Grid>
                        <Grid item
                            xs={2}>
                            <Typography variant='body2'>{data?.recentFall === true ? 'Yes' : 'No'}</Typography>

                        </Grid>
                        <Grid item
                            xs={6}>
                            <Typography variant='body2'>{data?.recentFallComment ? data?.recentFallComment : '-'}</Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={3}
                        sx={{ padding: '10px 1.5rem' }}
                    >
                        <Grid
                            item
                            xs={4}
                        >
                            <Typography variant='subtitle1'>Wheelchair Positioning</Typography>
                        </Grid>
                        <Grid item
                            xs={2}>
                            <Typography variant='body2'>{data?.orthotics === true ? 'Yes' : 'No'}</Typography>

                        </Grid>
                        <Grid item
                            xs={6}>
                            <Typography variant='body2'>{data?.orthoticsComment ? data?.orthoticsComment : '-'}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            )}
             <Stack>
                <Button
                    onClick={(event) => setSwallowingOpen((prev) => !prev)}
                    endIcon={iconSwallowing}
                    sx={{
                        padding: '0 1.5rem',
                        height: '70px',
                        borderRadius: '0px',
                        justifyContent: 'space-between',
                        color: 'black',
                    }}
                >
                    <Typography variant="h6">{'Swallowing'}</Typography>
                </Button>
                <Divider />
            </Stack>
            {swallowingOpen && (
                <Grid
                    spacing={3}>
                    <Grid
                        container
                        spacing={3}
                        sx={{ padding: '10px 1.5rem' }}
                    >
                        <Grid
                            item
                            xs={4}
                        >
                            <Typography variant='subtitle1'>Swallowing Abilities</Typography>
                        </Grid>
                        <Grid item
                            xs={2}>
                            <Typography variant='body2'>{data?.medicalStatusAndMedication === true ? 'Yes' : 'No'}</Typography>

                        </Grid>
                        <Grid item
                            xs={6}>
                            <Typography variant='body2'>{data?.medicalStatusAndMedicationComment ? data?.medicalStatusAndMedicationComment : '-'}</Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={3}
                        sx={{ padding: '10px 1.5rem' }}
                    >
                        <Grid
                            item
                            xs={4}
                        >
                            <Typography variant='subtitle1'>Weight Changes</Typography>
                        </Grid>
                        <Grid item
                            xs={2}>
                            <Typography variant='body2'>{data?.painAffectingDailyRoutine === true ? 'Yes' : 'No'}</Typography>

                        </Grid>
                        <Grid item
                            xs={6}>
                            <Typography variant='body2'>{data?.transferComment ? data?.transferComment : '-'}</Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={3}
                        sx={{ padding: '10px 1.5rem' }}
                    >
                        <Grid
                            item
                            xs={4}
                        >
                            <Typography variant='subtitle1'>New goal(s) per patient request</Typography>
                        </Grid>
                        <Grid item
                            xs={2}>
                            <Typography variant='body2'>{data?.painAffectingDailyRoutine === true ? 'Yes' : 'No'}</Typography>

                        </Grid>
                        <Grid item
                            xs={6}>
                            <Typography variant='body2'>{data?.transferComment ? data?.transferComment : '-'}</Typography>
                        </Grid>
                    </Grid>
                    
                </Grid>
            )}
        </>
    );
};

export default ExpansionDetails;
